import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../store';
import {
  adminLogin,
  brandLogin,
  sendVerificationCode,
  verifyVerificationCode,
  logoutUser,
  initializeAuth,
} from '../store/slices/authSlice';

export const useAuth = () => {
  const dispatch = useDispatch<AppDispatch>();
  const authState = useSelector((state: RootState) => state.auth);

  if (!authState) {
    throw new Error('useAuth must be used within a Redux Provider');
  }

  return {
    // State
    ...authState,

    // Actions
    adminLogin: (email: string, password: string) =>
      dispatch(adminLogin({ email, password })).unwrap(),

    brandLogin: (email: string, password: string) =>
      dispatch(brandLogin({ email, password })).unwrap(),

    sendVerificationCode: (email: string, purpose: string = 'login') =>
      dispatch(sendVerificationCode({ email, purpose })).unwrap(),

    verifyVerificationCode: (email: string, code: string) =>
      dispatch(verifyVerificationCode({ email, code })).unwrap(),

    logout: () => dispatch(logoutUser()).unwrap(),

    initialize: () => dispatch(initializeAuth()).unwrap(),
  };
};
